module.exports = __webpack_public_path__ + "img/new_shop_step.7ea68174.jpg";